import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { SnackBarService } from "src/app/core/services/snack-bar.service";
import { DownloadAllConfig } from "../download-all/models/download-all-config";

const IDS_PATTERN: string = "^(\\d+,(\\n)?)*\\d+\\n?$";

@Component({
    selector: "app-download-file-from-data",
    templateUrl: "./download-file-from-data.component.html",
    styleUrls: ["./download-file-from-data.component.scss"],
    standalone: false
})
export class DownloadFileFromDataComponent implements OnInit {
  @Input() inputLabel: string = "IDs";
  @Input() maxIdCount: number = 2000;
  @Input() idMinimum: number = 100000;
  @Input() downloadAllConfig: DownloadAllConfig;

  @Output() download: EventEmitter<string[]> = new EventEmitter();

  @ViewChild("textarea") textarea: ElementRef;

  form: UntypedFormGroup;

  constructor(private _fb: UntypedFormBuilder, private _snackBarService: SnackBarService) {}

  ngOnInit(): void {
    this.form = this._fb.group({
      data: [null, [Validators.required, Validators.pattern(IDS_PATTERN), idsValidator(this.maxIdCount, this.idMinimum)]],
    });
  }

  onDownloadClick(): void {
    if (!this.form.valid) {
      return;
    }

    const idStr: string = this.form.get("data").value;
    this.download.emit(idStr.split(","));

    this._snackBarService.show({
      message: `Success. Check your Downloads folder for the ${this.inputLabel} file.`,
      duration: 5000,
    });
  }

  onFindInvalidIdsClick(): void {
    const idStr: string = this.form.get("data").value;
    const idArr: string[] = idStr.split(",");

    const foundMinError = idArr.find(id => +id < this.idMinimum);
    if (foundMinError) {
      const searchStr = foundMinError.replace(/\n/, "");
      const textarea = this.textarea.nativeElement as HTMLTextAreaElement;
      let startIndex = idStr.indexOf(`${searchStr},`);

      if (startIndex === -1) {
        startIndex = idStr.length - searchStr.length;
      }

      const endIndex = startIndex + searchStr.length;
      textarea.focus();
      textarea.setSelectionRange(startIndex, endIndex);
    }
  }
}

function idsValidator(maxIdCount: number, idMinimum: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;

    if (!value || !new RegExp(IDS_PATTERN).test(value)) {
      return null;
    }

    const valueArray: string[] = value.split(",");

    if (valueArray.length > maxIdCount) {
      return {
        maxIds: true,
      };
    }

    const foundMinError = valueArray.find(value => +value < idMinimum);
    if (foundMinError) {
      return {
        minimumId: true,
      };
    }

    return null;
  };
}
